import { ControlSizesXL, ControlSizesLG, ControlSizesMD, ControlSizesSM } from '../../../helpers/controlSizes/controlSizes/index.js';

const BreadCrumbsSizesXL = ControlSizesXL;
const BreadCrumbsSizesLG = ControlSizesLG;
const BreadCrumbsSizesMD = ControlSizesMD;
const BreadCrumbsSizesSM = ControlSizesSM;

export { BreadCrumbsSizesLG, BreadCrumbsSizesMD, BreadCrumbsSizesSM, BreadCrumbsSizesXL };
